import { ChevronDown, ChevronUp, Info } from "lucide-react";
import { useState } from "react";

export function SectionHeader({ title, subtitle, collapsible = false, defaultOpen = true, children, tooltip, headerRight }) {
  const [open, setOpen] = useState(defaultOpen);
  return (
    <div className="bg-white rounded-xl border border-slate-200 shadow-sm overflow-hidden">
      <div
        className={`flex items-center justify-between px-6 py-4 border-b border-slate-100 ${collapsible ? "cursor-pointer hover:bg-slate-50" : ""}`}
        onClick={collapsible ? () => setOpen(o => !o) : undefined}
      >
        <div className="flex-1 min-w-0">
          <div className="flex items-center gap-2">
            <h3 className="text-sm font-semibold text-slate-900">{title}</h3>
            {tooltip && (
              <div className="relative group">
                <Info size={13} className="text-slate-500 hover:text-slate-500 cursor-help" />
                <div className="absolute left-0 top-5 w-64 bg-slate-800 text-white text-xs rounded-lg p-3 opacity-0 group-hover:opacity-100 pointer-events-none z-50 shadow-xl transition-opacity">
                  {tooltip}
                </div>
              </div>
            )}
          </div>
          {subtitle && <p className="text-xs text-slate-500 mt-0.5">{subtitle}</p>}
        </div>
        <div className="flex items-center gap-2" onClick={e => e.stopPropagation()}>
          {headerRight}
          {collapsible && (open ? <ChevronUp size={16} className="text-slate-600" /> : <ChevronDown size={16} className="text-slate-600" />)}
        </div>
      </div>
      {(!collapsible || open) && <div className="p-6">{children}</div>}
    </div>
  );
}

export function PageHeader({ title, subtitle, badge }) {
  // Page title is now shown in the main header bar
  // This component now shows only subtitle as a secondary description if provided
  if (!subtitle) return null;
  return (
    <div className="mb-3">
      <p className="text-xs text-slate-500">{subtitle}</p>
    </div>
  );
}

export function SnowflakeRequired({ message = "This section requires Snowflake FLUXX/MEAS connection." }) {
  return (
    <div className="flex flex-col items-center justify-center py-12 text-center">
      <div className="w-12 h-12 bg-slate-100 rounded-full flex items-center justify-center mb-3">
        <Info size={22} className="text-slate-600" />
      </div>
      <p className="text-sm text-slate-500 max-w-sm">{message}</p>
      <p className="text-xs text-slate-600 mt-1">Fix Snowflake credentials and click "Refresh Data" in the sidebar.</p>
    </div>
  );
}
